import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const SeparatorStyleWrapper = styled.span.withConfig({
  displayName: "Separator__SeparatorStyleWrapper",
  componentId: "sc-1vthfy0-0"
})(["margin:0 4px;"]);
const Separator = () => /*#__PURE__*/_jsx(SeparatorStyleWrapper, {
  children: '•'
});
Separator.displayName = 'Separator';
export default Separator;